<template>
  <div>
    <div id='filters' :class="{'active': active}">
      <div class="filterScroll">
        <div class="filterList">
          <h3>Regions</h3>
          <ul>
            <li v-for="region in regions" track-by="$index">
              <span>
                <input  type="checkbox" 
                        :id="'region_' + region.name" 
                        :checked="region.value"
                        @change="updateRegion(region)">
                <label :for="'region_' + region.name"></label>
              </span>
              <label class="filterLabel" :for="'region_' + region.name">{{region.name | slugToName}}</label>
            </li>
          </ul>
        </div>
        <div class="filterList">
          <h3>Type</h3>
          <ul>
            <li v-for="type in types">
              <span>
                <input  type="checkbox" 
                        :id="'type_' + type.name" 
                        :checked="type.value"
                        @change="updateType(type)">
                <label :for="'type_' + type.name"></label>
              </span>
              <label class="filterLabel" :for="'type_' + type.name">{{type.name | slugToName}}</label>
            </li>
          </ul>
        </div>
      </div>
      <a class="filters-btn" @click="toggleFilters()"><span><i class="fa fa-filter"></i></span><span class="text">Filters</span></a>
    </div>
  </div>
</template>
<script>
  import {
    updateType,
    updateRegion
  } from '../vuex/actions'
  import { mapState, mapActions } from 'vuex'
  export default {
    data () {
      return { active: false }
    },
    methods: {
      ...mapActions({
        updateType: 'updateType',
        updateRegion: 'updateRegion'
      }),
      toggleFilters () {
        this.active = !this.active
      }
    },
    computed: {
      ...mapState({
        regions: state => state.regions,
        types: state => state.types
      })
    },
    filters: {
      slugToName (string) {
        return string.replace('-', ' ').replace(/\b\w/g, l => l.toUpperCase())
      }
    }
  }
</script>
<style scoped>
  #filters {
    right: -300px;
    top:0;
    height: 100vh;
    width: 300px;
    position: absolute;
    z-index: 10;
    background-color: #043969;
    transition: all .5s ease;
    box-sizing:border-box;
    padding:0 1.5em;
    color:#fff;
    font-weight: 800;
  }

  #filters.active {
    right: 0;
  }
  #filters h3 {
    margin-bottom:1em;
  }

  #filters input[type="checkbox"] {
    float: left;
    clear: both;
    width: auto;
    margin-right: 3px;
    display:none;
  }
  .filterList {
    /*float:left;*/
    margin-right:1.5em;
  }
  .filterList ul {
    margin:0;
    padding:0;
  }
  .filterList ul li {
    list-style-type:none;
    margin: 3px 0;
  }
  /* ROUNDED TWO */
  .filterList ul li span {
    width: 22px;
    height: 22px;
    background: #fcfff4;
    display:inline-block;
    margin: 0 5px 10px 0;

    -webkit-border-radius: 50px;
    -moz-border-radius: 50px;
    border-radius: 50px;
    position: relative;
  }

  .filterList ul li span label {
    cursor: pointer;
    position: absolute;
    width: 16px;
    height: 16px;

    -webkit-border-radius: 50px;
    -moz-border-radius: 50px;
    border-radius: 50px;
    left: 3px;
    top: 3px;

    background:#043969;
  }

  .filterList ul li span label:after {
    -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
    filter: alpha(opacity=0);
    opacity: 0;
    content: '';
    position: absolute;
    width: 4px;
    height: 4px;
    background: #fcfff4;
    top: 4px;
    left: 4px;
    border: 2px solid #fcfff4;

    -webkit-border-radius: 50px;
    -moz-border-radius: 50px;
    border-radius: 50px;


    -webkit-transform: rotate(-45deg);
    -moz-transform: rotate(-45deg);
    -o-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }

  .filterList ul li span label:hover::after {
    -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=30)";
    filter: alpha(opacity=30);
    opacity: 0.3;
  }

  .filterList ul li span input[type=checkbox]:checked + label:after {
    -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=100)";
    filter: alpha(opacity=100);
    opacity: 1;
  }

  .filterLabel {
    position:relative;
    display:inline-block;
    top:-15px;
    cursor:pointer;
  }

  .filters-btn {
    position: absolute;
    text-align: center;
    left: -80px;
    top: 0;
    height: 80px;
    width: 80px;
    background-color: #043969;
    color: #fff;
    font-size: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .filters-btn:hover {
    cursor: pointer;
  }

  .filters-btn .text {
    font-size: 12px;
  }
  @media (max-width : 768px) {
    #filters {
      z-index:30;
      font-size:.875em;
      height:calc(100% - 60px);
    }
    .filterScroll {
      overflow-y: scroll;
      height: 100%;
    }
    .filters-btn {
      left:-60px;
      height:60px; 
      width:60px;
      font-size:1em;
    }
  }

  @media (max-width : 768px) and (orientation: landscape) {
    #filters {
      height: calc(100% - 35px);
    }

  }

</style>



// WEBPACK FOOTER //
// Filters.vue?29b55675